import parse from "html-react-parser";
import { ISkillDetail } from "../../model/SkillDetail.model";
import { ISkillGroup } from "../../model/SkillGroup.model";
import { ISkillLevel } from "../../model/SkillLevel.model";
import { ISkillPath } from "../../model/SkillPath.model";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../Accordion/Accordion";
import EmployeeProgressionOptions from "./EmployeeProgressionOptions";
import { ISkill } from "../../model/Skill.model";
import { FC } from "react";

import "./MobileSkillView.scss";

import { IEmployeeProgression } from "../../model/EmployeeProgression.model";
import { Link } from "react-router-dom";
import Checkbox from "../CheckboxComponent";
import SkillLevelCheckboxes from "./SkillLevelCheckboxes";

interface IMobileSkillViewProps {
  source: string,
  isManager: boolean,
  currentUpn: string | undefined,
  employeeProgressions: any[],
  employeeProgressionLevels: any[],
  skillPath: ISkillPath,
  filterArray: any,
  typeFilter: string,
  filteredSkillGroups: ISkillGroup[] | undefined,
  progressionLevelAdded(progressionLevel:any): void;
  progressionLevelUpdated(progressionLevel:any): void;
  progressionLevelRemoved(progressionLevel:any): void;
  bookmarkRemoved(bookmark: IEmployeeProgression): void;
  bookmarkAdded(bookmark: IEmployeeProgression): void;
}
const MobileSkillView: FC<IMobileSkillViewProps> = ({
  source,
  isManager,
  currentUpn,
  employeeProgressions,
  employeeProgressionLevels,
  skillPath,
  filterArray,
  typeFilter,
  filteredSkillGroups,
  bookmarkRemoved,
  bookmarkAdded,
  progressionLevelAdded,
  progressionLevelUpdated,
  progressionLevelRemoved
}) => {
  const masteredClicked = (event: any, skill: ISkill, level: ISkillLevel) => {
    var match =  employeeProgressionLevels.find((plevel) => plevel.skillId === skill.SkillId && plevel.skillLevelId === level.skillLevelId);
    if (!match) {
      var progressionLevel: any = {
        employeeProgressionLevelId: "",
        skillId: skill.SkillId,
        skillLevelId: level.skillLevelId,
        stage: "M"
      };
      progressionLevelAdded(progressionLevel);
      return;
    }
    progressionLevelRemoved(match);
  };

  const getSkillDetails = (skill: any, skillLevels: ISkillLevel[]) => {
    let returnArray: Array<any> = [];
    if (Array.isArray(skill.details) && Array.isArray(skillLevels)) {
      return (
        <>
          {skillLevels.map((level) => (
            <>
              <div className="mobile-skill-levels-container">
                <h3 className="m-t-1-5 m-b-50">{level.skillLevelName}</h3>
                {skill.details
                  .filter(
                    (det: ISkillDetail) =>
                      det.skillLevelId === level.skillLevelId
                  )
                  .map((detail: any) => (
                    <>
                      <p className="m-t--75 m-b--75">
                        {(parse((detail.skillText + "").replaceAll('<a href=', '<a target="_blank" rel="noopener noreferrer" href=')))}
                      </p>
                    </>
                  ))}
                  <SkillLevelCheckboxes
                    level={level}
                    skill={skill}
                    skillLevels={skillLevels}
                    isManager={isManager}
                    currentUpn={currentUpn}
                    employeeProgressionLevels={employeeProgressionLevels}
                    employeeProgressionLevelsLength={employeeProgressionLevels.length}
                    onMasteredAdded={progressionLevelAdded}
                    onMasteredChange={progressionLevelUpdated}
                    onMasteredRemoved={progressionLevelRemoved}
                  />
              </div>
            </>
          ))}
        </>
      );
    }
    //debugger;
    return <></>;
  };
  const HandleBookmarkRemoved = (bookmark: IEmployeeProgression) => {
    bookmarkRemoved(bookmark);
  }

    const showSkill = (skill:ISkill) => {
    if (typeFilter==="") return true;
    let bmstate = employeeProgressions.some(ep => ep.skillId === skill.SkillId);
    let masterState = employeeProgressionLevels.some(ep => ep.skillId === skill.SkillId && (ep.stage === "M"));
    let masterConfirmedLength = employeeProgressionLevels.filter(ep => ep.skillId === skill.SkillId && ep.stage === "MC").length;
    if (typeFilter === "B" && bmstate) return true;
    if (typeFilter === "M" && masterState) return true;
    if (typeFilter === "MC" && masterConfirmedLength > 0) return true;
    if (typeFilter === "F" && masterConfirmedLength > 2) return true;
    return false;
  };
  const createUniqueKey = (
    skillGroupId: string,
    SkillId: string,
    index: number
  ) => {
    return skillGroupId + "-" + SkillId + "-" + index;
  };

  const getAccordionColorBySkillPath = () => {
    switch (skillPath.skillPathId as any) {
      case 1:
        return "secondary";
      case 2:
        return "orange";
      case 3:
        return "purple";
      case 4:
        return "yellow";
      case 5:
        return "green";
      default:
        //20+
        return "orange";
    }
  }
  function HandleBookmarkAdded(bookmark: IEmployeeProgression): void {
    bookmarkAdded(bookmark)
  }

  return (
    <>
      {" "}
      {filteredSkillGroups &&
        (filteredSkillGroups as ISkillGroup[]) &&
        //@ts-ignore
        filteredSkillGroups
          .filter((sg) => source !== 'skills' || filterArray[sg.skillGroupId] !== undefined)
          .map((sklGrp: ISkillGroup, index: number) => (
            <Accordion>
              {sklGrp &&
                sklGrp.skills &&
                //@ts-ignore
                sklGrp.skills
                  .filter(
                    (sk) =>
                      source !== 'skills' || filterArray[sklGrp.skillGroupId].indexOf(sk.SkillId) > -1
                  )
                  .map((skill: ISkill) => (
                    <>
                    {skill && showSkill(skill) && (
                    <AccordionItem
                      key={createUniqueKey(
                        skill.skillGroupId,
                        skill.SkillId,
                        index
                      )}
                      id={createUniqueKey(
                        skill.skillGroupId,
                        skill.SkillId,
                        index
                      )}
                    >
                      <AccordionTrigger color={getAccordionColorBySkillPath()} headingLevel={3}>
                        {skillPath.skillPathName} : {sklGrp.skillGroupName} : {skill.skillName}
                      </AccordionTrigger>
                      <AccordionContent color={getAccordionColorBySkillPath()}>
                        <div className="core-desktop-max-width">
                          <div className="dis-flex dis-flex-jst-space-between dis-flex-aln-start">
                            <div>
                              <EmployeeProgressionOptions
                                source={source}
                                progression={employeeProgressions.find(
                                  (ep: any) => ep.skillId === skill.SkillId
                                )}
                                skill={skill}
                                skillLevels={
                                  (skillPath as any).skillLevels as ISkillLevel[]
                                }
                                isManager={isManager} bookmarkRemoved={HandleBookmarkRemoved} bookmarkAdded={HandleBookmarkAdded}
                              />
                            </div>
                            <Link className="btn-outlined-secondary-sml m-t-1" to={"/skillpath/" + skillPath.skillPathId + "?showAll=true"} style={{ display: "none" }} target='_blank'>View Skill</Link>
                          </div>
                          <div className="core-desktop-max-width">
                            {getSkillDetails(
                              skill,
                              (skillPath as any).skillLevels as ISkillLevel[]
                            )}
                          </div>
                        </div>
                      </AccordionContent>
                    </AccordionItem>)}
                    </>
                  ))}
            </Accordion>
          ))}
    </>
  );
};
export default MobileSkillView;